import * as React from "react"
import styled from "styled-components"
import useTranslation from "../../shared/utils/translation";
import TitlePrimary from "../../shared/components/text/TitlePrimary";
import {sectionMargin, subHeading} from "../../shared/utils/vars";
import PersonnelGrid from "../../shared/components/PersonnelGrid";

const Wrapper = styled.div`
  overflow: hidden;
  margin-top: 48px;
`
const TitleWrapper = styled.div`
  text-align: center;
  margin: ${sectionMargin}
`

const AboutUsWrapper = () => {
  const t = useTranslation()

  return (
    <Wrapper>
      <TitleWrapper>
        <TitlePrimary>{t("title.whoarewe")}</TitlePrimary>
      </TitleWrapper>
      <TitleWrapper>
        <TitlePrimary color={subHeading} small={true}>{t("who.paragraph")}</TitlePrimary>
      </TitleWrapper>
      <PersonnelGrid/>
    </Wrapper>
  )
}

export default AboutUsWrapper
